var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckmarcksvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_230_8",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_230_8)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -1.77734,
    y: -1.33398,
    width: 43.1111,
    height: 43.1111,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_230_8",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_230_8",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAACXBIWXMAAAsTAAALEwEAmpwYAAAE2klEQVR4nO2dTYgcRRTHf+uoI37mIGjixYuoibhGiSCaFb+JGxFdLyJ+R5Ql9+hB8Cbm5kETQfCk4AdusisoRpHEoxozWU3womYnF0GTlQjZCFJSUIPt0DNd3dPV9d5s/eEPyy7d/d5ve2uqX73qhaSkpKSkpKSkpP9rI7AALDsvuO8l1ajNwApg+my/N5VI16MLgW4O5J6PAxcl2KPrtSGQe96ZQP+n64AZ96fe8gRzLXDGA/TfwAbPc7ZcDDMljlGhK4Av+8AsAc8WAF8DHPKA3PMhd8wg2Wttc9fOHvcFsA7lOg84PASO/dk0MJE5xn59D3C0BOSe7TH35pxvuiAO+0tqo1hPegJaAvYA8wUffL7uunPtybmDB/lxFGt3DdBMQ7axqtX7AgAaT9tY1epjAQCNp22sajUvAKDxtI1VrQ4IAGg8vR/FU7s/BQA0nl7WOsXbLgCeKelZlOlm4C8B4ExJ25g3oWS42K4UssnAnpUwjFiYTwNvAR842yL818rGZOMxZtsP848yee52T7vtJgpEiwIgmMjuAGtDgu6vwq1m7wtZT46dnBFmWy+vXY8ISMwI88MhQE8JSMwI820hQJ9dora7GtwtsSRXWtsEJGiE2LIIplbBktBq8RH3Fx5U0wISNZG9lQY0oXCsXgF2AJc77/BsY8jzsb7F36CaVwZ5S04OL1Y8314a1CfKIeMeoauc09Z1GtFETS0BJiLkUUB3mxo67hsDyFYvjXB+2+ATVGsqdhAZYZC3DGgDLjO9uyQU5A2uPLjaIZtMG9n6OgGfD7xSU3AmoO107QGPYe90jde0XayvAxePCvl21+gdG6IRdCfn+fgoOw9uDBTYAeAFt7b4zRhAzsZxQxXQCwGCebdvamTrBW+PAeSebfdqaS0HCOTKnOucVRG2NMjWJ6qAPllzEP8A5w64VlnYEiFb/yGlnnHnkOv5wpYKufLQsTFAsD8Bl44AWzJkO22cZISNlHXXNToVYUuG3K1j/TDEA8sRVxceJDszeTPyw0iZB5ZaN5TaHoaDEe7sFaF38sFQfR24QsqPDcOeFAj5hzoeu4t0d81BdwpgSxyT70DpmmGnAuxYkH9tcs0wxFJWpwTsWJArz5WlLc52PGDHhNzoNrnQ7QadIbBjQ7b+uamhY2sDyXSAy3KuGxtyz0XTTVUtYb8BLwNPAe+4olRswNkbIViDo9VzApI0QvxMKMgtha1gJqCPhbqrNwtIzgjzLSFAzwhIzAjzg6H6OmInZoT5KgJpn4DkjBB/SkCtK/nmrnH1dznz/NrVdi962pXZujvn+jVCrJybSD7pcprL5GlzfmzIInNjarsN65o33Z9yDT7RN937aJNS2KeAm1CmWQHgTEk/j0K1lY3ZJySMvVW1XwBA4+mvUCxNu7fmUCxNLxj8EMXS9MrM91CsXQIAGk+/gWI94ZnkL26M3FtTzXvJnWvOtQf4HPMoitUuqI0cBu7PebH2XRU7ohZda3Dei7oXC2oX56Bca4HPK7x63raffV8C8rcFzYa9V8/3d8d+1kSBqEldAzwE3FpiCWi969gsgnzGnd9HLddia2O5eoR8xk47PUC/GjvI1fAPb5aAC2IHOS6aGtBkftoNRUk1atJN2ezOp9/d1O36RDgpKSkpKSkpiYz+Bae6rCgvwngZAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckmarcksvg);
export default __webpack_public_path__ + "static/media/checkmarcksvg.6eac04e989589d384bceb5ae99afc23c.svg";
export { ForwardRef as ReactComponent };